<p>
  equipo works!
</p>
<app-main-table></app-main-table>